import { useLazyLoadQuery } from 'react-relay';
import { usePathParam } from 'react-resource-router';
import { AtlassianAccountAnyUserQuery } from 'graphql/__generated__/AtlassianAccountAnyUserQuery.graphql';
import { ATLASSIAN_ACCOUNT_ANY_USER_QUERY } from 'graphql/AtlassianAccountAnyUserQuery';
import { type RecognitionScheduleQuery } from 'graphql/__generated__/RecognitionScheduleQuery.graphql';
import { RECOGNITION_SCHEDULE_QUERY } from 'graphql/RecognitionScheduleQuery';
import useLoggedInUser from 'utils/useLoggedInUser';

interface Props {
  currentProfileAaid: string;
}

export const useKudosModalData = ({ currentProfileAaid }: Props) => {
  const [pathProfileId] = usePathParam('pathProfileId');

  const loggedInUser = useLoggedInUser();
  const loggedInUserAaid = loggedInUser?.accountId ?? '';

  // Fetch user data only if we have profile data
  const userResponseData = currentProfileAaid
    ? useLazyLoadQuery<AtlassianAccountAnyUserQuery>(
        ATLASSIAN_ACCOUNT_ANY_USER_QUERY,
        { accountId: currentProfileAaid as string },
        { fetchPolicy: 'store-or-network' },
      )
    : null;

  // Fetch recognition schedule data
  const recognitionScheduleData = useLazyLoadQuery<RecognitionScheduleQuery>(
    RECOGNITION_SCHEDULE_QUERY,
    { aaid: loggedInUserAaid },
    {
      fetchPolicy: 'store-or-network',
    },
  );

  const userData = userResponseData?.user;
  const recognitionSchedule =
    recognitionScheduleData?.unified?.unifiedProfile?.gamification
      ?.recognitionSchedule;

  return {
    userData: userData || null,
    recognitionSchedule,
    loggedInUserAaid,
    pathProfileId: pathProfileId || '',
  };
};
